import React from 'react'

import config from '../../config.js'

import LineFormAccount from 'Skelet/src/components/LineFormAccount.js';

import img from '../../images/dieetclub-gezond-afvallen-recepten-gewoontes.jpg';


export default class extends React.Component {

  constructor(props) {
    super(props);

    this.state = {plan_active:"2", form_content:"register"};

    this.highlightNew = this.highlightNew.bind(this);
  }

  componentDidMount() {
    var elements = document.getElementsByClassName("plan");
    for(var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('mouseenter', this.highlightNew);
    }
  }

  highlightNew(e) {
    this.setState({plan_active:e.target.getAttribute("data-id")});
  }


  render() {
    return (
      <div>

        <div className="full greyish" style={{paddingBottom:"0"}}>

          <div className="wrap">
            <div className="col-2">
              <h1 style={{marginBottom:".3em", fontWeight:"400", textAlign:"center"}}>Alleen aan het afvallen? Doe met ons mee!</h1>
              <h2 style={{fontWeight:"400", fontSize:"1em", textAlign:"center", margin:"1em 0 2.3em"}}><b>Sluit je aan bij een gesloten sociaal netwerk waar je berichten, blogs, en recepten kunt delen. <span className="contact-label" style={{background:"#ff9934"}}>nog 274 gratis</span></b></h2>
              <LineFormAccount form_content={this.state.form_content} config={config} register_cta="Start NU als Clublid" />
              {/*<div style={{textAlign:"center", marginBottom:"5em"}}><button onClick={() => this.props.openModal("register")} className="btn btn-c btn-fat" style={{margin:"2em 0 0"}}>Start NU als Clublid{/*Start met een gratis account*//*}</button>{/*<p style={{textAlign:"center", margin:".5em 0 4em"}}><b>net als 2.187 anderen!</b></p>*//*}<small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%", textAlign:"center"}}>Je hebt enkel een e-mail adres nodig.</small></div>*/}
            </div>
            <div className="col-2">
              <div className="card" style={{maxWidth:"600px"}}>
                <img src={img} alt="Dieet.Club | Welkom!" className="screenshot" style={{margin:"0"}} />
              </div>
            </div>
          </div>

        </div>

        <div className="full accent">
          <div className="container content-txt">
            <h1>Hou je gewicht bij, geef jezelf een doel, en deel jouw eigen blogs en recepten op de publieke website!</h1>
          </div>
        </div>

        <div className="full greyish">
          <div className="wrap">
            <div className="col-2" style={{paddingTop:"3em", paddingBottom:"3em", marginBottom:"3em"}}>
              <table><tbody>
                <tr>
                  <td style={{paddingBottom:"1em"}}><p style={{margin:"0", fontWeight:"400", fontSize:"2em", lineHeight:"1em", textAlign:"center"}}>Gratis account</p></td>
                  <td style={{paddingBottom:"1em"}}><p style={{margin:"0", fontWeight:"400", fontSize:"2em", lineHeight:"1em", textAlign:"center"}}>Clublid <span className="contact-label" style={{background:"#ff9934"}}>nog 274 gratis</span></p></td>
                </tr>
                <tr>
                  <td style={{paddingBottom:"2em"}}><p style={{fontSize:"90%", textAlign:"center", margin:".7em 0"}}>Elk account heeft de volgende onderdelen, enkel voor jou zichtbaar:</p></td>
                  <td style={{paddingBottom:"2em"}}><p style={{fontSize:"90%", textAlign:"center", margin:".7em 0"}}>Als Clublid krijg je naast alle geweldige gratis onderdelen:</p></td>
                </tr>
                <tr>
                  <td style={{width:"50%", verticalAlign:"top"}}>
                    <ul style={{listStyleType:"square", paddingLeft:"1.1em"}}>
                      <li>gewicht-metingen</li>
                      {/*<li>gerechten</li>*/}
                      {/*<li>eetschema's</li>*/}
                      <li>dagboek</li>
                      <li>afslankplan</li>
                      {/*<li>voedingsregistratie</li>*/}
                      <li>en meer..</li>
                    </ul>
                  </td>
                  <td>
                    <ul style={{listStyleType:"square", paddingLeft:"1.1em"}}>
                      <li>claim jouw <b>@gebruikersnaam</b> en beheer jouw eigen <b>Club-profiel</b>.</li>
                      <li><span className="contact-label">binnenkort</span> maak <b>recepten</b>, zichtbaar voor alle club-leden, en publiekelijk op de website.</li>
                      <li><span className="contact-label">binnenkort</span> maak <b>blogs</b>, zichtbaar voor alle club-leden, en publiekelijk op de website.</li>
                      <li><span className="contact-label">2024</span> plaats <b>status-berichten</b>, zichtbaar voor alle club-leden.</li>
                      <li><span className="contact-label">2024</span> plaats <b>mijlpalen</b>, zichtbaar voor alle club-leden.</li>
                      <li><span className="contact-label">2024</span> bekijk de <b>timelines</b> van alle club-leden.</li>
                      <li>en meer..</li>
                    </ul>
                  </td>
                </tr>
              </tbody></table>
            </div>
            <div className="col-2 card" style={{paddingTop:"3em", paddingBottom:"3em", marginBottom:"3em"}}>
            <h2 style={{fontWeight:"400", fontSize:"1em", textAlign:"center", margin:"1em 0 2.3em"}}><b>Om het platform goed te beginnen zijn de eerste 300 gebruikers direct Clublid, helemaal gratis! Dit zal de gehele looptijd zo blijven, zo lang jouw account blijft bestaan.{/*De basis is gratis.*/} <span className="contact-label" style={{background:"#ff9934"}}>nog 274 gratis</span></b></h2>
              <p style={{textAlign:"center"}}><b style={{textDecoration:"line-through"}}>Word Clublid met een abonnement van slechts <span style={{marginRight:"3px", fontSize:"89%"}}>€</span>6,99 per maand, nu als tijdelijke introductie. Makkelijk opzegbaar.</b></p>
              <div id="plans" style={{padding:"0 1em"}}>
                <div className="plan-container">
                  <div className={(this.state.plan_active === "3") ? "plan active greenborders" : "plan greenborders"} data-id="3">
                    <span className="value-label" style={{textDecoration:"line-through"}}>STANDAARD</span>
                    <h1 style={{textDecoration:"line-through"}}>1</h1>
                    <p className="months" style={{textDecoration:"line-through"}}>maand</p>
                    <h4 style={{textDecoration:"line-through"}}><span style={{marginRight:"3px", fontSize:"89%"}}>€</span>6,99 per maand</h4>
                    <p className="savings">&nbsp;</p>
                    <p className="total" style={{textDecoration:"line-through"}}><span style={{marginRight:"3px", fontSize:"89%"}}>€</span>{(6.99 / 31).toFixed(2).toString().replace(".", ",")} per dag</p>
                  </div>
                </div>
                <div className="plan-container">
                  <div className={(this.state.plan_active === "2") ? "plan active greenborders" : "plan greenborders"} data-id="2">
                    <span className="value-label favorite" style={{textDecoration:"line-through"}}>AANBEVOLEN</span>
                    <h1 style={{textDecoration:"line-through"}}>6</h1>
                    <p className="months" style={{textDecoration:"line-through"}}>maanden</p>
                    <h4 style={{textDecoration:"line-through"}}><span style={{marginRight:"3px", fontSize:"89%"}}>€</span>5,14 per maand</h4>
                    <p className="savings" style={{textDecoration:"line-through"}}>Bespaar {Math.ceil(100 - (5.14 / 6.99 * 100))}%</p>
                    <p className="total" style={{textDecoration:"line-through"}}><span style={{marginRight:"3px", fontSize:"89%"}}>€</span>{(30.84 / 182).toFixed(2).toString().replace(".", ",")} per dag</p>
                  </div>
                </div>
                <div className="plan-container">
                  <div className={(this.state.plan_active === "1") ? "plan active greenborders" : "plan greenborders"} data-id="1">
                    <span className="value-label" style={{textDecoration:"line-through"}}>BEST VALUE</span>
                    <h1 style={{textDecoration:"line-through"}}>12</h1>
                    <p className="months" style={{textDecoration:"line-through"}}>maanden</p>
                    <h4 style={{textDecoration:"line-through"}}><span style={{marginRight:"3px", fontSize:"89%"}}>€</span>3,66 per maand</h4>
                    <p className="savings" style={{textDecoration:"line-through"}}>Bespaar {Math.ceil(100 - (3.66 / 6.99 * 100))}%</p>
                    <p className="total" style={{textDecoration:"line-through"}}><span style={{marginRight:"3px", fontSize:"89%"}}>€</span>{(43.92 / 365).toFixed(2).toString().replace(".", ",")} per dag</p>
                  </div>
                </div>
              </div>
              {/*<small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"center"}}>prijzen inclusief 21% BTW.</small>*/}
              <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-c btn-fat" style={{margin:"2em 0 0"}}>Start NU als Clublid{/*Start met een gratis account*/}</button>{/*<p style={{textAlign:"center", margin:".5em 0 4em"}}><b>net als 2.187 anderen!</b></p>*/}<small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%", textAlign:"center"}}>Je hebt enkel een e-mail adres nodig.</small></div>
              {/*<div>Plans automatically renew.<br/>Free to cancel any time.</div>*/}
              {/*<div><b>Terugkerende facturering, op elk moment te annuleren.</b><br/>Door op Doorgaan te tikken, wordt je betaling in rekening gebracht via je Google Play-account en wordt je abonnement automatisch verlengd met dezelfde pakketduur tegen dezelfde prijs, totdat je opzegt via de instellingen van de Google Play-store. Door op Doorgaan te tikken, ga je akkoord met onze <u>Voorwaarden</u>.</div>*/}
            </div>

          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Pricing.js